import {connect} from 'react-redux';

import {
  InboxesPanelId,
  makeCellsPanelId,
  makeViewerPanelId,
} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {updateSelectedFilterAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {
  CellsPanelPageSelector,
  makeGetCellsPanelCurrentPage,
  makeGetCellsPanelPage,
} from '../../../store/panels/cells/cellsPanelSelectors';
import {makeGetConversationSelection} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {makeCellsFilterProps, makeGetFilterProps} from '../cells/header/cellsHeaderContainer';
import {InboxesTopbar} from './inboxesTopbar';

/*
 * Props.
 */

interface InboxesTopbarContainerProps {
  inboxesPanelId: InboxesPanelId;
}

/*
 * Selectors.
 */

function getCellsPanelId(_state: unknown, props: InboxesTopbarContainerProps) {
  return makeCellsPanelId(props.inboxesPanelId);
}

function makeGetCellsContext<P>(getCellsPanelPage: CellsPanelPageSelector<P>) {
  return createSelector([getCellsPanelPage], (page) => page.cellsContext);
}

function makeGetCellsInboxesParameters<P>(getCellsPanelPage: CellsPanelPageSelector<P>) {
  return createSelector([getCellsPanelPage], (page) => page.parameters);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InboxesTopbarContainerProps>()(() => {
  const getCellsPanelPage = makeGetCellsPanelPage(getCellsPanelId);
  const getCellsPanelCurrentPage = makeGetCellsPanelCurrentPage(getCellsPanelId);
  const getCellsPanelPageParameters = makeGetCellsInboxesParameters(getCellsPanelPage);
  const getConversationSelection = makeGetConversationSelection(getCellsPanelPageParameters, getCellsPanelId);

  return {
    cellsContext: makeGetCellsContext(getCellsPanelCurrentPage),
    parameters: getCellsPanelPageParameters,
    filters: makeGetFilterProps(getCellsPanelPage, getCellsPanelCurrentPage),
    conversationSelection: getConversationSelection,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<InboxesTopbarContainerProps>()(() => ({
  navigateToLinkAction,
  updateSelectedFilterAction,
}));

export const InboxesTopbarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {parameters, filters: stateFilters} = stateProps;

    return {
      ...ownProps,
      ...stateProps,
      filters: makeCellsFilterProps(parameters, stateFilters, dispatchProps.navigateToLinkAction),
      panelId: makeViewerPanelId(ownProps.inboxesPanelId),
    };
  },
)(InboxesTopbar);
